import React from 'react';
import { connect } from 'react-redux';
import { Input, FormGroup, Label } from 'reactstrap';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../../../api-config';
import { auth, userService } from '../../../../../../../services';
import { DropDownList } from '@progress/kendo-react-dropdowns';

import IsLoading from '../../../../../../Shared/Loading/IsLoading';
import { Alert } from 'reactstrap';

import {
    addToPurchase,
    updatePurchase,
    removePurchaseItem,
    updateCostAction,
    changeView,
    setAlert
} from '../../../../../../../Redux/Actions/Admin/ManagePurchaseAndRenewalsActions';

import {
    getPaymentTypes
} from '../../../../../../../Redux/Actions/CommonActions';
import _ from 'lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Checkout extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            view: "Checkout",
            title: "Added Checkout",
            openBatches: [],
            SelectedBatch: null,
            SelectedBatchId: 0,
            Amount: 0,
            Tax: 0,
            Shipping: 8.25,
            GrandTotal: 0,
            Name: "",
            PaymentTypeId: 1,
            PaymentType: {
                name: "Credit",
                id: 1
            },
            CardViewModel: {
                NameOnCard: "",
                CardNumber: "",
                CardExpYear: "",
                CardExpMonth: "",
                CardCVC: "",
                IsAutoRenew: false
            },
            CheckViewModel: {
                CheckNumber: ""
            },
            TransactionLineItem: this.props.purchaseAndRenewals.purchaseList,
            isLoading: false
        }
    }

    componentDidMount() {
        this.props.getPaymentTypes();
        this.setTotal();

        axios.get(
            `${ROOT_API_URL}/ManageBatches/GetOpenBatches?paymentTypeId=${this.state.PaymentType.id}`,
            {
                headers: auth.authHeader()
            }
        ).then((response) => {

            const batches = response.data;

            if (batches.length) {

                for (var i = 0; i < batches.length; i++) {
                    batches[i].displayName = batches[i].batchJobId ? batches[i].batchJobId.toString() : '';
                    batches[i].displayName += batches[i].batchName ? ((batches[i].displayName ? ' - ' : '') + batches[i].batchName) : '';
                    //if (!batches[i].batchName) {
                    //    batches[i].batchName = batches[i].batchJobId;
                    //}
                }

                this.setState({
                    openBatches: batches
                });
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(prevProps.purchaseAndRenewals.purchaseList, this.props.purchaseAndRenewals.purchaseList)) {
            this.setState({
                TransactionLineItem: this.props.purchaseAndRenewals.purchaseList
            })
        }
    }

    handleChange = ({ target }) => {
        this.setState({ [target.name]: target.value });
    };

    actualCostChange = (e, index) => {
        const newState = Object.assign({}, this.state);
        newState.TransactionLineItem[index].ActualCost = Number(e.target.value);
        this.setState(
            newState,
            () => this.setTotal()
        );
    };

    actualCostProductChange = (e, index, key) => {
        const newState = Object.assign({}, this.state);
        newState.TransactionLineItem[index].productLineItems[key].ActualCost = Number(e.target.value);
        this.setState(
            newState,
            () => this.setTotal()
        );
    };

    handleOnCardNumberChange = ({ target }) => {

        var originalValue = this.state.CardViewModel.CardNumber.replace(/\s/g, ''); //Get old input value
        const value = target.value.replace(/\s/g, '').replace(/\D/g, '');              //Get new input value
        if ((value.match(/^[0-9999999999999999]|^$/) || value == "") && value.length <= 16) {
            this.setState({
                CardViewModel:{
                    NameOnCard: this.state.CardViewModel.NameOnCard,
                    CardExpYear: this.state.CardViewModel.CardExpYear,
                    CardExpMonth: this.state.CardViewModel.CardExpMonth,
                    CardCVC: this.state.CardViewModel.CardCVC,
                    IsAutoRenew: this.state.CardViewModel.IsAutoRenew,
                    CardNumber: this.cc_format(value)
                }
                
            });
        }
        else {
            this.setState({ 
                CardViewModel:{
                    CardNumber: this.cc_format(originalValue),
                    NameOnCard: this.state.CardViewModel.NameOnCard,
                    CardExpYear: this.state.CardViewModel.CardExpYear,
                    CardExpMonth: this.state.CardViewModel.CardExpMonth,
                    CardCVC: this.state.CardViewModel.CardCVC,
                    IsAutoRenew: this.state.CardViewModel.IsAutoRenew
                }
            });
        }
    }

    cc_format(value) {
        var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
        var matches = v.match(/\d{4,16}/g);
        var match = matches && matches[0] || '';
        var parts = [];

        for (var i = 0; i < match.length; i += 4) {
            parts.push(match.substring(i, i + 4))
        }

        if (parts.length) {
            return parts.join(' ')
        } else {
            return value
        }
    }

    handleCardChange = ({ target }) => {
        const newState = Object.assign({}, this.state);
        newState.CardViewModel[target.name] = target.value;
        this.setState(newState);
    }


    handleCheckChange = ({ target }) => {
        const newState = Object.assign({}, this.state);
        newState.CheckViewModel[target.name] = target.value;
        this.setState(newState);
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ isLoading: true })
        var TransactionLineItemsNew = [];

        for (var i = 0; i < this.state.TransactionLineItem.length; i++) {
            let lineItemData = this.state.TransactionLineItem[i];

            if (lineItemData.view === "Donation") {
                TransactionLineItemsNew.push({
                    DonationModel: lineItemData
                })
            } else if (lineItemData.view === "Membership") {
                TransactionLineItemsNew.push({
                    MembershipModel: lineItemData
                })
            } else if (lineItemData.view === "Subscription") {
                TransactionLineItemsNew.push({
                    MagazineSubscriptionModel: lineItemData
                })
            } else if (lineItemData.view === "RenewMembership") {
                TransactionLineItemsNew.push({
                    RenewalModel: lineItemData
                })
            } else if (lineItemData.view === "RenewSubscription" || lineItemData.view === "Renew Subscription") {
                TransactionLineItemsNew.push({
                    MagazineSubscriptionRenewalModel: lineItemData
                })
            } else if (lineItemData.view === "ProductOrder") {

                lineItemData.Tax = Number(this.state.Tax);
                lineItemData.Shipping = Number(this.state.Shipping);

                TransactionLineItemsNew.push({
                    TransactionOrderViewModel: lineItemData
                })
            }
            else if (lineItemData.view === "AdditionalDues") {
                TransactionLineItemsNew.push({
                    AdditionalDuesModel: lineItemData
                })
            }
        }

        const options = { method: 'POST', headers: auth.authHeader() };
        axios.post(`${ROOT_API_URL}/ManageTransaction/SaveTransaction`, {
            Amount: Number(this.state.GrandTotal),
            BatchId: this.state.SelectedBatchId,
            Name: this.state.Name,
            PaymentTypeId: this.state.PaymentTypeId,
            UserId:this.props.purchaseAndRenewals.userInfo.userId || null,            
            MembershipId: this.props.purchaseAndRenewals.userInfo.membershipId || null,
            ReceiptEmail: this.props.purchaseAndRenewals.userInfo.email || "",
            CardViewModel: this.state.CardViewModel.NameOnCard !== "" ? this.state.CardViewModel : null,
            CheckViewModel: this.state.CheckViewModel.CheckNumber !== "" ? this.state.CheckViewModel : null,
            TransactionLineItem: TransactionLineItemsNew
            //PaymentType: this.state.PaymentType
        }, options)
            .then((response) => {
                this.props.refreshGrid();
                this.setState({ subscriptionData: response.data, isLoading: false }, () => this.props.setAlert(true, response.message, 'success'));
                this.props.changeView({ view: "Success" });
                setTimeout(() => {
                    this.props.setAlert(false, "");
                }, 5000)
            })
            .catch((response) => {
                // Show response.message by default. Use response.response.data.exceptionLanguage if exists
                var err = response.message ? response.message : 'Network Connection Error';

                if (response.response && response.response.data && response.response.data.exceptionLanguage) {
                    err = response.response.data.exceptionLanguage;
                }

                this.setState({ isLoading: false }, () => this.props.setAlert(true, err, 'danger'))
            });
    };

    setTotal = () => {
        var totalAmount = 0;
        this.props.purchaseAndRenewals.purchaseList.forEach(function (purchase) {
            if (purchase.ActualCost) {
                totalAmount += Number(purchase.ActualCost);
            } else {
                if (purchase.productLineItems) {
                    purchase.productLineItems.forEach(function (product) {
                        totalAmount += Number(product.ActualCost);
                    })
                }
            }
        });

        this.setState({
            Amount: totalAmount
        }, () => {
            this.shipping();
        })


    }

    shipping = () => {
        var totalShippingAmount = 0;
        this.props.purchaseAndRenewals.purchaseList.forEach(function (purchase) {
            if (purchase.productLineItems) {
                //totalShippingAmount = 8.25 + totalShippingAmount;
                totalShippingAmount = 8.25;
            }
        });

        this.setState({
            Shipping: totalShippingAmount
        }, () => {
            this.tax();
        })
    }

    tax = () => {
        var totalTaxAmount = 0;

        if (this.props.purchaseAndRenewals.purchaseList.length > 0) {
            //totalTaxAmount = Number(Number(Number(8.25) * 0.0825).toFixed(2));
            //console.log(totalTaxAmount);

            for (var i = 0; i < this.props.purchaseAndRenewals.purchaseList.length; i++) {
                let purchase = this.props.purchaseAndRenewals.purchaseList[i];

                // only purchasing a product/Gate sign has tax.

                if (purchase.view && purchase.view == 'ProductOrder') {
                    if (purchase.ActualCost) {
                    } else {
                        if (purchase.productLineItems) {

                            for (var j = 0; j < purchase.productLineItems.length; j++) {
                                let product = purchase.productLineItems[j];
                                //totalTaxAmount += Number(Number((Number(product.ActualCost) * 0.0825) + Number(totalTaxAmount)).toFixed(2));

                                const currTax = (totalTaxAmount == 0 ? Number(Number(Number(this.state.Shipping) * 0.0825).toFixed(2)) : totalTaxAmount);
                                //console.log('Curr Tax: ' + currTax);
                                totalTaxAmount = Number((Number(product.ActualCost) * 0.0825) + Number(currTax)).toFixed(2);
                                //console.log('Totl Tax: ' + totalTaxAmount);
                            }
                        }
                    }
                }
            }
        }

        this.setState({
            Tax: totalTaxAmount
        }, () => {
            this.grandTotal();
        })
    }

    grandTotal = () => {
        let SubTotal = Number(this.state.Amount).toFixed(2);
        let Shipping = Number(this.state.Shipping).toFixed(2);
        let Tax = Number(Number(this.state.Tax).toFixed(2));
        let grandTotal = (Number(SubTotal) + Number(Shipping) + Number(Tax)).toFixed(2);
        this.setState({
            GrandTotal: grandTotal
        });

        this.props.updateSuggestTotal(grandTotal);
    }

    handlePaymentChange = (event) => {
        this.setState({
            PaymentType: event.target.value,
            PaymentTypeId: event.target.value.id,
            SelectedBatch: null,
            SelectedBatchId: null,
            CardViewModel: {
                NameOnCard: "",
                CardNumber: "",
                CardExpYear: "",
                CardExpMonth: "",
                CardCVC: "",
                IsAutoRenew: false
            },
            CheckViewModel: {
                CheckNumber: ""
            },
        })

        axios.get(
            `${ROOT_API_URL}/ManageBatches/GetOpenBatches?paymentTypeId=${event.target.value.id}`,
            {
                headers: auth.authHeader()
            }
        ).then((response) => {
            const batches = response.data;

            if (batches.length) {

                for (var i = 0; i < batches.length; i++) {
                    batches[i].displayName = batches[i].batchJobId ? batches[i].batchJobId.toString() : '';
                    batches[i].displayName += batches[i].batchName ? ((batches[i].displayName ? ' - ' : '') + batches[i].batchName) : '';
                    //if (!batches[i].batchName) {
                    //    batches[i].batchName = batches[i].batchJobId;
                    //}
                }

                this.setState({
                    openBatches: batches
                });
            }
        });
    }

    handleBatchChange = (event) => {
        this.setState({
            SelectedBatch: event.target.value,
            SelectedBatchId: event.target.value.batchJobId
        })
    }

    formatAsDollar(amount) {
        var t = '$' + (Number(amount)).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        return t;
    }

    asyncRemovePurchaseItem = async (index) => {
        this.props.removePurchaseItem(index);
    }

    handleRemovePurchaseItem = async (event, index) => {

        event.stopPropagation();
        await this.asyncRemovePurchaseItem(index);
        this.setTotal();
    }
    render() {
        return (
            this.state.isLoading ? (
                <IsLoading message="Sending...." />
            ) : (
                <div className="checkout">
                    <Alert
                        color={this.props.purchaseAndRenewals.color}
                        isOpen={this.props.purchaseAndRenewals.visible}
                        style={{ position: 'fixed', width: '100%', height: '50px', zIndex: '1', top: '2px', left: '0' }}
                    >
                        {this.props.purchaseAndRenewals.message}
                    </Alert>
                    <h1>Checkout</h1>
                    <div className="row headerRow">
                        <div className="col-md-5">
                            Item Name
                        </div>
                        <div className="col-md-3 right">
                            <p>Suggested Cost</p>
                        </div>
                        <div className="col-md-3 right">
                            <p>Actual Cost</p>
                        </div>
                        <div className="col-md-1 right">
                        </div>
                    </div>
                    {this.props.purchaseAndRenewals.purchaseList.length > 0 ?
                        <ul className="checkoutList">
                            {
                                this.props.purchaseAndRenewals.purchaseList.map((item, index) => {
                                    item.id = index;
                                    if (item.view === "ProductOrder") {
                                        return (
                                            <ul>
                                                <li>{item.view} - {item.Name}</li>
                                                {item.productLineItems.map((product, key) => {
                                                    return (
                                                        <li className="purchaseListItem" key={key}>
                                                            <div className="row">
                                                                <div className="col-md-5">
                                                                    Product - {product.ProductName}
                                                                </div>
                                                                <div className="col-md-3 right">
                                                                    <p>{Number(product.SuggestedCost).toFixed(2)}</p>
                                                                </div>
                                                                <div className="col-md-3 right dollarSignContainer">
                                                                    <span>$</span>
                                                                    <input
                                                                        id="ActualCost"
                                                                        type="number"
                                                                        step=".01"
                                                                        bsSize="sm"
                                                                        value={product.ActualCost || 0}
                                                                        onChange={(event) => this.actualCostProductChange(event, index, key)}
                                                                        name="ActualCost"
                                                                    />
                                                                </div>
                                                                <div
                                                                    className="col-md-1 right"
                                                                    onClick={
                                                                        (event) => {
                                                                            this.handleRemovePurchaseItem(event, index);
                                                                        }
                                                                    }>
                                                                    <FontAwesomeIcon icon="times" />
                                                                </div>
                                                            </div>
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        )
                                    } else {
                                        return (
                                            <li className="purchaseListItem" key={index}>
                                                <div className="row">
                                                    <div className="col-md-5">
                                                        {item.view} - {item.Name}
                                                    </div>
                                                    <div className="col-md-3 right">
                                                        <p>{this.formatAsDollar(item.SuggestedCost)}</p>
                                                    </div>
                                                    <div className="col-md-3 right dollarSignContainer">
                                                        <span>$</span>
                                                        <input
                                                            id="ActualCost"
                                                            type="number"
                                                            step=".01"
                                                            value={item.ActualCost || 0}
                                                            onChange={(event) => this.actualCostChange(event, index)}
                                                            name="ActualCost"
                                                        />
                                                    </div>
                                                    <div
                                                        className="col-md-1 right"
                                                        onClick={
                                                            (event) => {
                                                                this.handleRemovePurchaseItem(event, index);
                                                            }
                                                        }>
                                                        <FontAwesomeIcon icon="times" />
                                                    </div>
                                                </div>
                                            </li>
                                        )
                                    }
                                })
                            }
                        </ul> : ""
                    }
                    <hr />
                    <div className="row">
                        <div className="col-md-6">
                            <h4>Tax</h4>
                        </div>
                        <div className="col-md-6 right flexInline">
                            <h4>{this.formatAsDollar(this.state.Tax)}</h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <h4>Shipping</h4>
                        </div>
                        <div className="col-md-6 right flexInline">
                            
                                {/*<h4>{this.formatAsDollar(this.state.Shipping)}</h4>*/}
                                <h4>$</h4>
                                <Input
                                    id="shipping"
                                    type="text"
                                    bsSize="sm"
                                    value={this.state.Shipping || 0}
                                    onChange={(event) => {
                                        const regex = new RegExp('^[0-9]*\\.?[0-9]{0,2}$');

                                        if (regex.test(event.target.value)) {
                                            this.setState(
                                                { Shipping: event.target.value },
                                                () => {
                                                    this.tax();
                                                }
                                            );
                                        }
                                    }}
                                    name="shipping"
                                />
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-md-6">
                            <h4>Total</h4>
                        </div>
                        <div className="col-md-6 right">
                            <h4>{this.formatAsDollar(this.state.GrandTotal)}</h4>
                        </div>
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <div className="form-group ">
                            <h2 className="callout">Select and enter <span className="highlight">payment information</span></h2>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <DropDownList data={this.props.common.paymentTypes}
                                id="paymentTypeId"
                                name="name"
                                textField="name"
                                dataItemKey="id"
                                onChange={this.handlePaymentChange}
                                value={this.state.PaymentType}
                                width={300}
                                />
                            </div>
                        </div>
                        <h2>Select Batch</h2>
                        <div className="row">
                            <div className="col-md-12">
                                <DropDownList
                                    required={true}
                                    data={this.state.openBatches}
                                    //textField="batchName"
                                    textField="displayName"
                                    dataItemKey="batchJobId"
                                    onChange={this.handleBatchChange}
                                    value={this.state.SelectedBatch}
                                    width={300}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <label htmlFor="Name" className="">Name</label>
                                <Input
                                required={true}
                                    id="Name"
                                    type="text"
                                    value={this.state.Name || ""}
                                    onChange={this.handleChange}
                                    name="Name"
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="Amount" className="">Amount</label>
                                <p className="staticAmount">{this.formatAsDollar(this.state.GrandTotal)}</p>
                            </div>
                        </div>
                        {this.state.PaymentType.name === "Credit" ? 
                            <div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="NameOnCard" className="">Name On Card</label>
                                        <Input
                                            required={true}
                                            id="NameOnCard"
                                            type="text"
                                            value={this.state.CardViewModel.NameOnCard || ""}
                                            onChange={this.handleCardChange}
                                            name="NameOnCard"
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="CardNumber" className="">Card Number</label>
                                        <Input
                                            required={true}
                                            id="CardNumber"
                                            value={this.state.CardViewModel.CardNumber || ""}
                                            onChange={this.handleOnCardNumberChange}
                                            name="CardNumber"
                                            placeholder="XXXX XXXX XXXX XXXX"
                                            pattern="\d{4} \d{4,6} \d{4,5} \d{4,0}"
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <label htmlFor="CardExpMonth" className="">Card Exp Month</label>
                                        <Input
                                            required={true}
                                            id="CardExpMonth"
                                            type="text"
                                            value={this.state.CardViewModel.CardExpMonth || ""}
                                            onChange={this.handleCardChange}
                                            name="CardExpMonth"
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="CardExpYear" className="">Card Exp Year</label>
                                        <Input
                                            required={true}
                                            id="CardExpYear"
                                            type="text"
                                            value={this.state.CardViewModel.CardExpYear || ""}
                                            onChange={this.handleCardChange}
                                            name="CardExpYear"
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="CardCVC" className="">Card CVC</label>
                                        <Input
                                            required={true}
                                            id="CardCVC"
                                            type="text"
                                            value={this.state.CardViewModel.CardCVC || ""}
                                            onChange={this.handleCardChange}
                                            name="CardCVC"
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <sup style={{ color: "red" }}>*Your method of payment will be charged for the amount of {this.formatAsDollar(this.state.GrandTotal)} after clicking "Submit"</sup>
                                    </div>
                                </div>
                            </div>
                        : ""}
                            {this.state.PaymentType.name === "Check" ? 
                                <div className="row">
                            <div className="col-md-12">
                                <label htmlFor="CheckNumber" className="">Check Number</label>
                                <Input
                                    required={true}
                                    id="CheckNumber"
                                    type="text"
                                    value={this.state.CheckViewModel.CheckNumber || ""}
                                    onChange={this.handleCheckChange}
                                    name="CheckNumber"
                                />
                                    </div>
                                    </div>
                        : ""}
                        <button className="submitBtn" onClick={() => this.handleSubmit}>Submit</button>
                    </form>
                </div>
            )
        )
    }
}

function mapStateToProps(state) {
    return {
        purchaseAndRenewals: state.purchaseAndRenewals,
        common: state.common
    };
}

export default connect(mapStateToProps, {
    addToPurchase,
    updatePurchase,
    removePurchaseItem,
    changeView,
    getPaymentTypes,
    updateCostAction,
    setAlert
})(Checkout);